import React, { ReactNode } from "react";
import {CustomerStatus, useAuthContext} from "store/auth";
import { Navigate } from "react-router-dom";

interface Props {
  isPage?: boolean;
  children?: ReactNode;
}

export function CanLoadGuard({ isPage = false, children }: Props) {
  const [{ user }] = useAuthContext();

  if (user.StatusId !== CustomerStatus.Suspended.toString()) return <>{children}</>;

  if (isPage) return <Navigate to="/" />;
  return null;
}

export function CanLoadPage({ children }: Props) {
  const [{ user }] = useAuthContext();
  const isSuspended = user.StatusId === CustomerStatus.Suspended.toString() ;

  React.useEffect(() => {
    if(!isSuspended) return ;

    const flagSelected = document.getElementsByClassName('flag-dropdown');
    Array.from(flagSelected).forEach(f => f.classList.add('disabled'));

    const inputs = document.querySelectorAll('input');
    inputs.forEach(i => i.disabled = true);
  } ,[isSuspended,children])

  return <div className={ isSuspended ? "suspended" : ""}>{children}</div>;
}

export default CanLoadGuard;
